// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"e47e5c76","543":"75d811ea","596":"87eedb3b","660":"75be1432"}[chunkId] + ".chunk.js";
};